module.exports = __webpack_public_path__ + "img/6.1e29f32c.jpg";